import { DataFilterIProps } from "~/entity/Logs/model/schema";

interface IvideonFilterUrlValues {
  userId?: unknown;
  eventType?: unknown;
  startDate?: unknown;
  endDate?: unknown;
}

/**
 * Значения фильтра из URL (строки; даты в формате yyyy-MM-dd) →
 * REST-параметры GET /logs/activity. Если фильтр пуст — undefined.
 */
export const formatDataForServer = (
  values: IvideonFilterUrlValues,
): DataFilterIProps | undefined => {
  const userId = values.userId ? Number(values.userId) : undefined;
  const eventType = values.eventType ? String(values.eventType) : undefined;
  const startDate = values.startDate ? String(values.startDate) : undefined;
  const endDate = values.endDate ? String(values.endDate) : undefined;

  if (userId == null && !eventType && !startDate && !endDate) {
    return undefined;
  }

  return { userId, eventType, startDate, endDate };
};
